/**
 * Sold-out variant experience.
 *
 * 1) Keeps the shopper's color selection in place when they pick a sold-out
 *    variant. The Kaching bundle widget re-asserts its own (in-stock)
 *    variant via synthetic change events whenever a sold-out color is
 *    selected, which snapped the picker back. Real user selections fire
 *    trusted events; the widget's resets are untrusted and get cancelled
 *    for a short window after a trusted choice.
 *
 * 2) Ensures the gallery actually shows the sold-out color. The theme's own
 *    variant-change render can be disrupted mid-flight by the widget, so
 *    after a trusted selection of an unavailable variant we set the active
 *    media (and keep the price visible) ourselves.
 */
(function () {
  var WINDOW_MS = 4000;
  var lastTrusted = null; // { name, value, time }
  var productData = null;

  function isColorRadio(el) {
    return (
      el instanceof HTMLInputElement &&
      el.type === 'radio' &&
      el.name &&
      el.name.trim().indexOf('Color') === 0
    );
  }

  function loadProduct() {
    if (productData) return Promise.resolve(productData);
    var match = window.location.pathname.match(/\/products\/[^/?#]+/);
    if (!match) return Promise.resolve(null);
    return fetch(match[0] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { productData = p; return p; })
      .catch(function () { return null; });
  }

  function findVariantByColor(product, color) {
    if (!product) return null;
    var idx = product.options.findIndex(function (o) {
      return (o.name || o).toString().toLowerCase().indexOf('color') === 0;
    });
    var key = 'option' + ((idx === -1 ? 0 : idx) + 1);
    return product.variants.find(function (v) { return v[key] === color; }) || null;
  }

  function slideMatches(el, variantId) {
    var ids = (el.getAttribute('data-variant-ids') || '').split(',');
    return ids.some(function (id) { return id.trim() === String(variantId); });
  }

  function showVariantMedia(variantId) {
    var viewer = document.querySelector('media-gallery [id^="GalleryViewer-"]');
    if (!viewer) return;
    var slides = viewer.querySelectorAll('li[data-media-id]');
    var target = null;
    slides.forEach(function (el) {
      if (el.hasAttribute('data-variant-ids') && slideMatches(el, variantId)) target = el;
    });
    if (!target) return;
    slides.forEach(function (el) { el.classList.remove('is-active'); });
    target.classList.add('is-active');
    target.style.removeProperty('display');
    slides.forEach(function (el) {
      if (el !== target && el.hasAttribute('data-variant-ids')) {
        el.style.setProperty('display', 'none', 'important');
      }
    });
    // keep the matching thumbnail visible too
    var thumbs = document.querySelectorAll('.thumbnail-list__item[data-variant-ids]');
    thumbs.forEach(function (t) {
      t.style.setProperty('display', slideMatches(t, variantId) ? 'block' : 'none', 'important');
    });
  }

  var soldOutSelected = false;
  var priceObserver = null;

  function restorePrice() {
    var price = document.querySelector('.product__info-container [id^="price-"]');
    if (!price) return;
    price.classList.remove('hidden', 'visibility-hidden');
    if (!priceObserver) {
      // Competing scripts keep re-hiding the price after their own renders;
      // keep it visible for as long as a sold-out color stays selected.
      priceObserver = new MutationObserver(function () {
        if (soldOutSelected && price.classList.contains('hidden')) {
          price.classList.remove('hidden');
        }
      });
      priceObserver.observe(price, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function enforceSoldOutView(color) {
    loadProduct().then(function (product) {
      var variant = findVariantByColor(product, color);
      if (!variant) return;
      soldOutSelected = !variant.available;
      if (variant.available) return; // theme handles in-stock fine
      showVariantMedia(variant.id);
      restorePrice();
    });
  }

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!isColorRadio(t)) return;

      if (e.isTrusted) {
        lastTrusted = { name: t.name, value: t.value, time: Date.now() };
        // let the theme's own render run first, then enforce the sold-out view
        setTimeout(function () { enforceSoldOutView(t.value); }, 700);
        setTimeout(function () { enforceSoldOutView(t.value); }, 1800);
        return;
      }

      if (
        lastTrusted &&
        Date.now() - lastTrusted.time < WINDOW_MS &&
        t.value !== lastTrusted.value
      ) {
        e.stopImmediatePropagation();
        e.preventDefault();
        t.checked = false;
        // The picker may have been re-rendered since the click, so find the
        // current input for the user's choice rather than a stale reference.
        var current = document.querySelector(
          'input[type="radio"][name="' + CSS.escape(lastTrusted.name) + '"][value="' + CSS.escape(lastTrusted.value) + '"]'
        );
        if (current) current.checked = true;
      }
    },
    true
  );
})();
